/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha17 = props => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 3193.000000 4609.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,4609.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M8990 45490 c-100 -68 -151 -119 -215 -215 -66 -99 -101 -176 -155
   -340 -69 -213 -87 -312 -155 -850 -68 -538 -161 -1253 -171 -1317 l-5 -36 219
   -4 c295 -4 279 13 241 -251 -12 -81 -20 -149 -18 -151 2 -1 796 1 1764 5 968
   4 3839 8 6380 9 4463 2 6477 8 6489 21 4 3 0 57 -9 120 -21 164 -20 195 8 203
   12 3 111 9 219 12 108 4 202 10 208 14 8 5 -14 169 -80 591 -112 721 -203
   1271 -236 1442 -68 347 -227 650 -386 733 -27 15 -75 19 -283 25 -254 8 -5245
   24 -10730 34 l-3010 6 -75 -51z"
      />
      <path
        d="M7950 42683 l-516 -3 -1294 -1372 c-712 -754 -1603 -1698 -1979
   -2097 -376 -399 -811 -859 -965 -1021 -440 -462 -597 -634 -1071 -1175 -272
   -312 -387 -456 -459 -576 -71 -117 -257 -485 -325 -642 -67 -155 -169 -456
   -216 -637 -20 -80 -48 -168 -60 -197 -35 -75 -168 -567 -194 -718 -6 -33 -30
   -202 -52 -375 l-42 -315 -7 -875 c-4 -481 -9 -2520 -10 -4530 -1 -2010 -5
   -5027 -9 -6705 l-6 -3050 -25 -50 c-14 -27 -33 -61 -43 -75 -45 -63 -74 -112
   -116 -195 -57 -114 -63 -173 -31 -281 25 -85 22 -104 -29 -174 -37 -52 -39
   -81 -7 -137 40 -70 40 -77 2 -127 -67 -88 -72 -165 -17 -281 l31 -68 -27 -39
   c-16 -21 -38 -52 -51 -69 -35 -50 -46 -105 -33 -162 6 -27 11 -59 11 -71 0
   -12 11 -45 26 -73 l25 -51 -37 -48 c-32 -43 -36 -53 -32 -94 5 -47 14 -71 60
   -150 l27 -45 -36 -57 c-47 -76 -47 -114 1 -214 20 -42 36 -82 36 -89 0 -7 -16
   -54 -35 -104 -19 -49 -35 -102 -35 -115 0 -17 20 -46 60 -89 l59 -64 -44 -59
   c-25 -32 -45 -65 -45 -72 0 -7 30 -56 67 -109 l66 -95 -18 -69 c-23 -90 -17
   -151 20 -189 15 -16 64 -47 109 -69 90 -43 98 -54 132 -176 9 -33 24 -76 34
   -95 22 -43 27 -94 40 -375 17 -371 41 -776 50 -865 5 -47 16 -157 25 -245 19
   -182 66 -444 101 -555 12 -41 41 -149 63 -240 190 -777 668 -1668 1181 -2205
   58 -60 126 -135 151 -165 26 -30 147 -158 270 -285 309 -319 2096 -2167 2959
   -3060 985 -1021 1316 -1362 1514 -1562 l171 -173 663 0 664 0 -8 92 c-5 51 -9
   131 -9 178 l0 85 4095 -3 c4457 -2 10550 -18 10559 -27 3 -3 -4 -74 -16 -158
   -12 -84 -20 -153 -19 -154 3 -3 608 -21 971 -28 l310 -7 2145 2223 c1180 1222
   2352 2436 2605 2698 253 261 500 518 549 570 311 336 527 740 802 1506 154
   426 297 968 368 1391 55 325 57 369 52 1129 -5 667 -14 4124 -36 14830 -5
   2640 -13 4861 -16 4935 -10 231 -59 580 -120 855 -97 435 -263 899 -470 1315
   -181 362 -196 381 -805 1060 -136 151 -266 293 -288 315 -45 43 -2969 3188
   -4035 4340 -351 380 -646 698 -655 707 -15 16 -52 16 -656 2 -352 -9 -642 -18
   -644 -20 -2 -1 5 -69 15 -149 16 -137 16 -147 0 -163 -15 -15 -68 -18 -574
   -24 -849 -10 -12768 -20 -13492 -11 l-635 8 3 65 c1 36 9 114 17 173 21 152
   25 148 -128 145 -67 -2 -354 -4 -637 -5z m8235 -2573 c915 -85 1772 -648 2288
   -1503 142 -236 248 -467 352 -766 36 -107 81 -224 100 -261 58 -116 185 -235
   324 -305 54 -27 58 -27 390 -41 1230 -52 4894 -214 5387 -239 160 -8 303 -19
   318 -24 14 -6 101 -24 193 -41 200 -37 361 -77 498 -123 940 -320 1628 -1078
   1929 -2124 93 -325 155 -766 176 -1253 15 -347 33 -2118 75 -7105 8 -1001 21
   -2315 27 -2920 16 -1515 20 -1284 -87 -5940 -90 -3906 -100 -4244 -131 -4470
   -133 -957 -616 -1756 -1354 -2241 -433 -284 -841 -430 -1480 -528 -209 -32
   -553 -48 -2320 -106 -1338 -44 -2102 -71 -2635 -92 -522 -20 -693 -22 -2507
   -22 -1072 -1 -1948 -4 -1948 -8 0 -5 -82 -8 -182 -8 -205 0 -242 1 -3178 70
   -465 11 -1140 27 -1500 35 -360 8 -842 20 -1070 25 -228 5 -611 14 -850 20
   -239 5 -498 12 -575 15 -77 4 -331 8 -565 10 -625 5 -803 19 -1240 96 -321 56
   -453 89 -620 152 -813 312 -1423 862 -1805 1627 -157 315 -241 583 -304 970
   -29 177 -31 206 -41 655 -16 746 -28 1438 -65 3675 -19 1152 -40 2343 -46
   2645 -12 564 -9 1603 11 3715 29 3059 51 5573 60 7075 14 2161 28 3364 40
   3490 34 328 189 775 385 1112 326 558 837 1023 1430 1303 328 156 709 286 943
   324 165 27 371 34 4047 136 1694 47 1907 57 2025 96 135 46 227 101 315 189
   103 103 149 192 204 400 218 820 706 1498 1368 1901 490 298 1066 435 1618
   384z"
      />
      <path
        d="M15765 39349 c-368 -49 -681 -238 -909 -549 -64 -87 -159 -284 -191
   -395 -24 -85 -26 -103 -26 -325 0 -252 3 -278 52 -416 144 -408 444 -709 850
   -852 174 -62 273 -77 489 -77 175 1 206 3 307 27 411 97 723 341 907 705 92
   183 116 303 116 563 -1 177 -11 260 -45 370 -65 206 -170 376 -334 541 -205
   205 -437 332 -721 394 -90 20 -391 28 -495 14z"
      />
      <path
        d="M8734 4973 c8 -179 5 -188 -59 -203 -22 -5 -140 -10 -262 -10 -211 0
   -223 -1 -223 -19 0 -58 281 -2480 345 -2979 45 -346 124 -657 242 -952 86
   -216 144 -305 239 -371 l43 -29 5693 1 c3131 1 6270 5 6975 8 l1282 6 29 28
   c40 39 106 157 170 305 96 224 236 672 266 852 3 19 17 152 31 295 14 143 68
   672 120 1175 115 1114 152 1479 161 1591 l7 86 -262 5 c-168 3 -266 9 -273 16
   -8 8 -6 36 5 99 9 48 19 118 23 156 l7 67 -519 0 c-546 0 -7802 15 -11738 25
   l-2309 5 7 -157z"
      />
    </g>
  </svg>
);
export default extendIcon(Deha17);
